module.exports = __webpack_public_path__ + "static/media/shopware_certified_developer.324d4593.svg";